import { Component, OnInit } from '@angular/core';
import { Caso } from './casos.model';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

// services
import { EventService } from 'src/app/core/service/event.service';
import { CasosService } from './casos.service';
import { PlantillaService } from '../plantillas/plantillas.service';

// constants
import { EventType } from 'src/app/core/constants/events';

// models
import { Plantilla } from '../plantillas/plantillas.model';

@Component({
  selector: 'app-new-caso',
  templateUrl: './new-caso.component.html',
  styleUrls: ['./new-caso.component.scss']
})
export class NewCasoComponent implements OnInit {

  constructor(
    private eventService: EventService,
    private casoService: CasosService,
    private plantillaService: PlantillaService,
    private router: Router) { }

  model = {
    numero_expediente: '',
    fecha_solicitud: '',
    id_plantilla: ''
  }

  plantillas: Plantilla[] = [];

  ngOnInit(): void {
    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: 'Nuevo caso',
        breadCrumbItems: [{ label: 'Casos', path: '.' }, { label: 'Nuevo caso', path: '.', active: true }]
      }
    );

    // Obtener las plantillas
    this.plantillaService.getPlantillas().subscribe(
      (data: Plantilla[]) => {
        this.plantillas = data;
      },
      (error: any) => { // Tipo explícito para el parámetro error
        console.error('Error fetching plantillas:', error);
      }
    );
  }

  onSubmit(form: NgForm) {
    const caso: Caso = {
      numero_expediente: form.value.numero_expediente,
      fecha_solicitud: form.value.fecha_solicitud,
      id_plantilla: form.value.id_plantilla
    };

    this.casoService.newCaso(caso)
      .subscribe(res => {
        this.router.navigate(['/casos']);
      },
      (error: any) => { // Tipo explícito para el parámetro error
        console.error('Error creating new caso:', error);
      });
      
  }
}
